import {Path} from 'react-hook-form'
import {IApplicationFormData, IWizardEmployment} from '../../../models/application-form'

export const employmentPath = (field: keyof IWizardEmployment): Path<IApplicationFormData> => {
  return `employment.${field}` as Path<IApplicationFormData>
}
